module.exports = __webpack_public_path__ + "static/media/welcome.33a0da2a.mp3";